<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Privacy Policy</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <div class="form-row">
          <b-col md="12">
            <div v-html="settings.privacyPolicy"></div>
          </b-col>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import { authHeader } from '../../_helpers';
  import axios from 'axios'

  export default {
    name: "PrivacyPolicy",
    components: {
        [Select.name]: Select,
        [Option.name]: Option
    },
    computed: {
      currentUser () {
        return this.$store.state.authentication.user.user
      },
      settings () {
        return this.$store.state.settings.current;
      }
    },
    created() {
      const { dispatch } = this.$store;
      dispatch('settings/getSettings', this.currentUser.clientId)
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
</style>
